module.exports = __webpack_public_path__ + "static/img/hazmat-suit_256.4b74e44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hazmat-suit_256.png
// module id = 4zg/
// module chunks = 0